<script lang="ts">
    import {marked} from 'marked';
    import {getSanitize} from 'core/svelte-context/context';

    export let markdown = '';

    const sanitize = getSanitize();

    $: htmlContent = marked.parseInline(markdown, {async: false});
</script>

{@html sanitize(htmlContent)}